/**
 * Overlay Action Creators
 */
import { Actions } from "components/OverLay/store/Actions";

function showOverlay(): object {
  return {
    type: Actions.SHOW_OVERLAY,
  };
}

function hideOverlay(): object {
  return {
    type: Actions.HIDE_OVERLAY,
  };
}

export { showOverlay, hideOverlay };



// WEBPACK FOOTER //
// ./src/components/OverLay/store/ActionCreators.tsx